const light = {
  '--background': 'white',
  '--divider': 'var(--color-grey-200)',
  '--border-bottom': 'var(--color-grey-200)'
}

export const colorSchemes = {
  light
}
